import { FETCH_ADMIN } from '../actions'

import { ADMIN_DATA, initialState, INVOICES } from './consts'

export const handleFetchAdmin = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_ADMIN.action:
      return {
        ...state,
        adminData: {
          ...ADMIN_DATA,
          loading: true,
        },
        invoices: {
          ...INVOICES,
        },
      }
    case FETCH_ADMIN.success:
      return {
        ...state,
        adminData: {
          ...ADMIN_DATA,
          data: action.payload,
        },
      }
    case FETCH_ADMIN.failed:
      return {
        ...state,
        adminData: {
          ...ADMIN_DATA,
          error: action.error,
        },
      }
    default:
      return state
  }
}
